"use strict";

exports.__esModule = true;
exports.default = void 0;
var _coreJsData = _interopRequireDefault(require("./_coreJsData.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(_coreJsData.default && _coreJsData.default.keys && _coreJsData.default.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _default = exports.default = isMasked;